import React from 'react';
import './InputField.css';

/**
 * InputField Component
 * 
 * Reusable input field component for forms
 * Supports different input types and displays validation state
 * 
 * @component
 * @param {Object} props
 * @param {string} props.label - Input label text
 * @param {string} props.type - Input type (text, email, password, tel, etc.)
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.value - Input value
 * @param {function} props.onChange - Change handler function
 * @param {boolean} props.required - Whether field is required
 * @param {string} props.error - Error message to display
 * @param {string} props.name - Input name attribute
 * @param {boolean} props.disabled - Whether input is disabled
 */
const InputField = ({
  label,
  type = 'text',
  placeholder,
  value,
  onChange,
  required = false,
  error = '',
  name,
  disabled = false,
  ...rest
}) => {
  // Dummy change handler if none provided
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <div className="input-field">
      {/* Label (optional) */}
      {label && (
        <label className="input-field__label">
          {label}
          {required && <span className="input-field__required">*</span>}
        </label>
      )}

      {/* Input element */}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`input-field__input ${error ? 'input-field__input--error' : ''}`}
        {...rest}
      />

      {/* Error message */}
      {error && (
        <span className="input-field__error-message">
          {error}
        </span>
      )}
    </div>
  );
};

export default InputField;


